import React from "react";
import { PHASES } from "../../data";
import SectionHead from "./SectionHead";
import { Check } from "lucide-react";

export default function Phases() {
  return (
    <section className="sec" style={{ background: "#00030F", borderTop: "1px solid var(--line)", borderBottom: "1px solid var(--line)" }}>
      <div className="mx-auto max-w-[1080px] px-4 lg:max-w-[1440px] lg:px-12">
        <SectionHead index={PHASES.index} title={PHASES.title} center />
        <p className="mt-5 mx-auto max-w-[60ch] text-center" style={{ fontSize: "1.08rem" }}>{PHASES.sub}</p>

        <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-4 mt-10">
          {PHASES.items.map((p) => (
            <div key={p.n} className="panel p-7">
              <div className="flex items-baseline gap-3">
                <span className="display blue" style={{ fontSize: "1.6rem" }}>{p.n}</span>
                <h3 className="display" style={{ fontSize: "1.5rem" }}>{p.name}</h3>
              </div>
              <p className="mt-4" style={{ fontSize: "1rem" }}>{p.body}</p>
            </div>
          ))}
        </div>

        <div className="panel p-7 mt-6" style={{ borderColor: "rgba(46,107,255,0.4)" }}>
          <div className="kicker" style={{ color: "var(--blue-2)" }}>{PHASES.formatTitle}</div>
          <ul className="mt-5 space-y-3 lg:space-y-0 lg:grid lg:grid-cols-2 lg:gap-x-12 lg:gap-y-4" style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {PHASES.format.map((f, i) => (
              <li key={i} className="flex items-start gap-3">
                <Check size={18} className="blue mt-1 shrink-0" strokeWidth={2.5} />
                <span style={{ fontSize: "1rem" }}>{f}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
